import React, { useContext } from 'react'

import withFade from '../../HOC/withFade'
import withQuestion from '../../HOC/withQuestion'
import { ApplicationFormContext } from '../../ApplicationForm/ApplicationFormContext'
import { GroupedQuestionsForReorderingCaseV2 } from './GroupedQuestionsForReorderingCase.v2'
import { GroupedQuestionsForReorderingCaseV4 } from './GroupedQuestionsForReorderingCase.v4'
import QuestionComponentProps from '../../../Questions/question-component-props'

export const GroupedQuestionsForReorderingCase = withFade(withQuestion((props: QuestionComponentProps) => {
  const { featureSwitches } = useContext(ApplicationFormContext)
  const { personalDetailsV4_2 } = featureSwitches ?? {}

  // GroupedQuestionsForReorderingV4 = Title, first name, surname
  if (personalDetailsV4_2) return <GroupedQuestionsForReorderingCaseV4 {...props} />
  // GroupedQuestionsForReorderingV2 = Title, first name, surname, mobile number, email
  return <GroupedQuestionsForReorderingCaseV2 {...props} />
}))
